import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { addStatistics } from '../api';
import { sleep } from '@ivy/fts/utils';
let ShareModel = class ShareModel extends Vue {
    constructor() {
        super(...arguments);
        this.showBottomBar = false;
        this.longEnter = false;
        this.pageHidden = false;
        this.shareOk = false;
    }
    mounted() {
        this.showBottomBar = env.type === 'wx' ? false : true;
        this.needVisible && this.initEvent();
    }
    close() {
        this.$emit('update:showShare', false);
        this.$emit('share-success');
    }
    initEvent() {
        document.addEventListener('visibilitychange', this.visibilitychangeFn);
    }
    async visibilitychangeFn() {
        var isHidden = document.hidden;
        if (!isHidden && this.needVisible) {
            if (this.longEnter) {
                this.longEnter = false;
                let { data } = await this.$axios.post('/api/activity/appActivity/teamActivity/giveOrganizerReward', {
                    team_activity_id: this.id,
                });
                console.log('xxxx', data);
                this.$emit('update:showShare', false);
                if (data.message) {
                    this.$emit('share-success');
                }
            }
        }
        else {
            this.$emit('update:showShare', false);
        }
    }
    async destroyed() {
        document.removeEventListener('visibilitychange', this.visibilitychangeFn);
    }
    async touchstart() {
        if (env.type === 'wx') {
            clearTimeout(this.startTime);
            this.startTime = setTimeout(async () => {
                await addStatistics({
                    activity_id: this.activityId,
                    event_type: 'SharePosters_xszd',
                    p1: this.id,
                    p2: 'h5',
                    p3: this.userType,
                });
                console.log('是否开启了队长分享奖励', this.isOrganizerReward);
                if (+this.isOrganizerReward) {
                    this.longEnter = true;
                }
                // this.$emit('update.showShare', false)
                // this.$emit('share-success')
            }, 800);
        }
    }
    touchmove() {
        if (env.type === 'wx') {
            clearTimeout(this.startTime);
        }
    }
    touchend() {
        if (env.type === 'wx') {
            clearTimeout(this.startTime);
        }
    }
    async onNativeShare() {
        console.log('app分享回调触发');
        let { data } = await this.$axios.post('/api/activity/appActivity/teamActivity/giveOrganizerReward', {
            team_activity_id: this.id,
        });
        console.log('xxxx', data);
        this.$emit('update:showShare', false);
        if (data.message) {
            this.$emit('share-success');
        }
    }
    async shareWx(type) {
        if (this.shareOk)
            return this.$Toast('分享中...');
        this.setDebounce();
        this.$Toast('分享中...');
        this.openWxShare(type);
    }
    async openWxShare(type) {
        try {
            await addStatistics({
                activity_id: this.activityId,
                event_type: 'SharePosters_xszd',
                p2: this.appName,
                p4: this.userType,
                p5: this.id,
            });
        }
        catch { }
        await env.sharePlatform({
            type: 'image',
            pic_url: this.imgUrl,
            platform: type,
        });
    }
    async setDebounce() {
        this.shareOk = true;
        await sleep(3000);
        this.close();
        this.shareOk = false;
    }
};
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "imgUrl", void 0);
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "activityId", void 0);
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "id", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], ShareModel.prototype, "showShare", void 0);
tslib_1.__decorate([
    Prop({ default: '组队成功后队员每人均可得一份奖品' })
], ShareModel.prototype, "tipText", void 0);
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "appName", void 0);
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "userType", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], ShareModel.prototype, "needVisible", void 0);
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "isOrganizerReward", void 0);
ShareModel = tslib_1.__decorate([
    Component
], ShareModel);
export default ShareModel;
